import { render, staticRenderFns } from "./add-paperfiles.html?vue&type=template&id=09bbe628&scoped=true&external"
import script from "./add-paperfiles.js?vue&type=script&lang=js&external"
export * from "./add-paperfiles.js?vue&type=script&lang=js&external"
import style0 from "./add-paperfiles.scss?vue&type=style&index=0&id=09bbe628&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bbe628",
  null
  
)

export default component.exports